import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CalendarAdmin from "@/pages/CalendarAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/calendar" element={<CalendarAdmin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Outfit, sans-serif",
            borderRadius: "12px",
            background: "#FDFBF7",
            color: "#4A403A",
            border: "1px solid #EADED9",
          },
        }}
      />
    </div>
  );
}

export default App;
